import { render, staticRenderFns } from "./businessModule.vue?vue&type=template&id=34b1ed02&scoped=true&"
import script from "./businessModule.vue?vue&type=script&lang=js&"
export * from "./businessModule.vue?vue&type=script&lang=js&"
import style0 from "./businessModule.vue?vue&type=style&index=0&id=34b1ed02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1ed02",
  null
  
)

export default component.exports